import { Client, HttpMethod, Hub } from '@bimone/bimtrack-core';
import HubAssembler from './assemblers/HubAssembler';
import { HubDto } from './assemblers/types';

export default class HubClient {
  public constructor(
    private readonly bimTrackApiUrl: string,
    private readonly token?: string,
    private readonly signal?: AbortSignal,
    private readonly timeOutMs?: number
  ) {}

  public async fetchHubs(): Promise<Hub[]> {
    const client = new Client<HubDto[]>({
      baseUrl: this.bimTrackApiUrl,
      endpoint: 'v3/hubs',
      token: this.token,
      signal: this.signal,
      timeOutMs: this.timeOutMs,
    });

    const hubsDto = await client.sendRequest(HttpMethod.GET);

    return hubsDto.map((hubDto: HubDto) => HubAssembler.toDomain(hubDto));
  }
}
